// extracted by mini-css-extract-plugin
module.exports = {"root":"PayPlan_root__3PNEJ"};